import { render, staticRenderFns } from "./InvoiceConsult.vue?vue&type=template&id=12b42768&"
import script from "./InvoiceConsult.vue?vue&type=script&lang=js&"
export * from "./InvoiceConsult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports